var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getMainDashboard } from '@/main/utils/role-utils';
import { ButtonKVBase, currentAccountState } from '@/presentation/components';
import { IconBlock } from '@/presentation/components/icons';
import { useLogout } from '@/presentation/hooks';
import React, { useState } from 'react';
import { Card, Container } from 'react-bootstrap';
import { useNavigate } from 'react-router';
import { useRecoilValue } from 'recoil';
const Unauthorized = ({ test }) => {
    var _a, _b, _c, _d, _e, _f;
    const [loading, setLoading] = useState(false);
    const { getCurrentAccount } = useRecoilValue(currentAccountState);
    const currentAccount = getCurrentAccount();
    const navigate = useNavigate();
    const logout = useLogout();
    const onLogout = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        yield logout();
        setLoading(false);
    });
    const mainDash = getMainDashboard(currentAccount);
    return (React.createElement(Container, { className: "d-flex flex-column justify-content-center align-items-center", style: { width: '100vw', height: '100vh', backgroundColor: '#F3F3F9', maxWidth: '100vw' } },
        React.createElement(Card, { style: { borderRadius: 20, padding: '4rem' } },
            React.createElement(Card.Body, { className: "text-center" },
                React.createElement(Card.Title, null, "You are not authorized to view this page"),
                React.createElement(Card.Text, null,
                    React.createElement("div", null,
                        React.createElement(IconBlock, null)),
                    React.createElement("div", null,
                        React.createElement("small", null, `${(_a = currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.attributes) === null || _a === void 0 ? void 0 : _a.given_name} ${(_b = currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.attributes) === null || _b === void 0 ? void 0 : _b.family_name}`)),
                    React.createElement("div", null,
                        React.createElement("small", { style: { fontSize: 10 } }, (_c = currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.attributes) === null || _c === void 0 ? void 0 : _c.email)),
                    React.createElement("div", null,
                        React.createElement("small", null, (_f = (_e = (_d = currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.signInUserSession) === null || _d === void 0 ? void 0 : _d.idToken) === null || _e === void 0 ? void 0 : _e.payload['cognito:groups']) === null || _f === void 0 ? void 0 : _f.join(','))),
                    React.createElement("div", { style: { padding: '1rem' } },
                        React.createElement(ButtonKVBase, { type: "button", btnBackgroundGradient: "linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)", onClick: () => navigate(mainDash), loading: loading }, "Return to dashboard"),
                        React.createElement("small", { style: { fontSize: 10 } }, mainDash)),
                    React.createElement("div", { style: { padding: '1rem' } },
                        React.createElement(ButtonKVBase, { type: "button", btnBackgroundGradient: "linear-gradient(90deg, #FFA800 0%, #7F1BFF 100%)", onClick: onLogout, loading: loading }, "Log out")))))));
};
export default Unauthorized;
